function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../../../_snowpack/pkg/react.js";
import { jsx as __cssprop } from "../../../_snowpack/pkg/@emotion/react.js";

/**
 * MobileMenuButton
 *
 * A burger button for the mobile menu
 *
 * @todo animate me
 *
 * @param {ExpectedProps} props expected from mobile menu
 * @param {React.ForwardedRef<HTMLButtonElement>} ref forwarded from parant
 * @returns {JSX.Element} Burger button
 */
const MobileMenuButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  return __cssprop("button", _extends({
    type: "button",
    tabIndex: 0,
    css: {
      "display": "inline-flex",
      "alignItems": "center",
      "justifyContent": "center",
      "borderRadius": "0.375rem",
      "--tw-text-opacity": "1",
      "color": "rgba(31, 41, 55, var(--tw-text-opacity))",
      ".dark &": {
        "--tw-text-opacity": "1",
        "color": "rgba(255, 255, 255, var(--tw-text-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgba(75, 85, 99, var(--tw-bg-opacity))",
        ":focus": {
          "--tw-ring-offset-color": "#111827"
        }
      },
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(209, 213, 219, var(--tw-bg-opacity))",
      ":focus": {
        "outline": "2px solid transparent",
        "outlineOffset": "2px",
        "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
        "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
        "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
        "--tw-ring-offset-width": "2px",
        "--tw-ring-opacity": "1",
        "--tw-ring-color": "rgba(88, 200, 223, var(--tw-ring-opacity))",
        "--tw-ring-offset-color": "#f3f4f6"
      }
    },
    ref: ref
  }, props), __cssprop("span", {
    css: {
      "position": "absolute",
      "width": "1px",
      "height": "1px",
      "padding": "0",
      "margin": "-1px",
      "overflow": "hidden",
      "clip": "rect(0, 0, 0, 0)",
      "whiteSpace": "nowrap",
      "borderWidth": "0"
    },
    "aria-readonly": true
  }, "Open main menu"), __cssprop("svg", {
    "x-heroicon": "outline/menu",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    css: {
      "height": "1.5rem",
      "width": "1.5rem"
    },
    "aria-hidden": true
  }, __cssprop("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M4 6h16M4 12h16M4 18h16"
  })));
});
export default MobileMenuButton;